export class SparseMap<R> {
  public size = 0;
  private keys: Map<number, number> = new Map();
  private data: Array<R> = [];
  private idRef: Array<number> = [];

  clear() {
    this.size = 0;
    this.keys.clear();
    this.data = [];
    this.idRef = [];
  }

  add(key: number, value: R) {
    this.size += 1;
    this.keys.set(key, this.data.push(value) - 1);
    this.idRef.push(key);
  }

  remove(key: number) {
    this.size -= 1;
    const idx = this.keys.get(key);
    if (idx != null) {
      const removed = this.data[idx];
      this.keys.delete(key);
      const lastIdx = this.data.length - 1;
      if (idx === lastIdx) {
        this.data.pop();
        this.idRef.pop();
      } else {
        const last = this.data.pop()!;
        const lastId = this.idRef.pop()!;
        this.data[idx] = last;
        this.idRef[idx] = lastId;
        this.keys.set(lastId, idx);
      }
      return removed;
    }
  }

  get(key: number) {
    const idx = this.keys.get(key);
    if (idx == null) {
      console.warn(`Entity ${key} not found!`);
      return;
    }
    return this.data[idx];
  }

  forEach(callback: (value: R, index: number, array: R[]) => void) {
    this.data.forEach(callback);
  }

  map<M>(callback: (value: R, index: number, array: R[]) => M) {
    this.data.map<M>(callback);
  }

  filter(callback: (value: R, index: number, array: R[]) => boolean) {
    return this.data.filter(callback);
  }

  find(callback: (value: R, index: number, array: R[]) => boolean) {
    return this.data.find(callback);
  }
}
